import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

import { User } from '../../types/users';
import { BaseQuery, Response, TagTypes } from '../apiBase.types';

const getUserEndpoints = (
  builder: EndpointBuilder<BaseQuery, TagTypes, 'API'>
) => ({
  getCurrentUser: builder.query<Response<User>, void>({
    query: () => ({
      url: 'users/me',
      method: 'GET'
    }),
    providesTags: [TagTypes.CurrentUser]
  })
});

export default getUserEndpoints;
